import { createBuilderModule } from '../../../builder';
import { EventAgendaSection } from './EventAgendaSection';

export default createBuilderModule(EventAgendaSection, {
  name: 'EventAgendaSection',
  image: '',
  inputs: [
    {
      name: 'eventID',
      type: 'string',
      required: true,
      helperText:
        'The value of the "event-data" attribute found in the Accelevents embed snippet',
    },
    {
      name: 'heading',
      type: 'string',
      required: false,
    },
    {
      name: 'headingSize',
      type: 'string',
      enum: ['small', 'medium', 'large'],
      required: false,
    },
    {
      name: 'headingAlignment',
      type: 'string',
      enum: ['left', 'center'],
      required: false,
    },
  ],
});
